module.exports = __webpack_public_path__ + "static/media/GTBSLong1w522@2x.f38cdf95.jpg";